import { compose } from 'lodash/fp'
import withState from './withState'
import Notifications from './Notifications'

export default compose(withState)(Notifications)
